// TransformerContext.js
import { createContext, useContext, useRef } from 'react';

const TransformerContext = createContext();

export const TransformerProvider = ({ children }) => {
    const transformerRef = useRef();

    return (
        <TransformerContext.Provider value={transformerRef}>
            {children}
        </TransformerContext.Provider>
    );
};

export const useTransformer = () => {
    return useContext(TransformerContext);
};